import { IEstablishment } from '@/common/integrations/menhir/employee/establishments/establishments.types';
import { amountSchema } from '@/common/utils/zod';
import { MoneyUtils } from '@coverflex-tech/hypernova-utils';
import { z } from 'zod';

const voucherSchemaForAmount = z
  .object({
    amount: amountSchema,
    availableAmount: amountSchema,
  })
  .superRefine((values, ctx, ..._) => {
    if (MoneyUtils.isGreater(values.amount, values.availableAmount)) {
      ctx.addIssue({
        path: ['amount'],
        code: z.ZodIssueCode.custom,
        message:
          'dashboard.submit_childcare_voucher.fields.amount.errors.not_enough_balance',
      });
    }
    if (values.amount.amount <= 0) {
      ctx.addIssue({
        path: ['amount'],
        code: z.ZodIssueCode.custom,
        message: 'errors.input.should_be_greater_than',
      });
    }
    return values;
  });

const voucherSchemaForEstablishment = z.object({
  establishment: z.custom<IEstablishment>(Boolean, 'errors.input.required'),
});

const voucherSchemaFor3yChildConfirmation = z.object({
  confirmChildAge: z.custom<boolean>(Boolean, 'errors.input.required'),
});

export const defaultVoucherSchema = z.intersection(
  voucherSchemaForAmount,
  voucherSchemaForEstablishment
);

export const voucherSchemaWithChildAgeConfirmation = z.intersection(
  defaultVoucherSchema,
  voucherSchemaFor3yChildConfirmation
);

export type TVoucherFormSchema =
  | z.infer<typeof defaultVoucherSchema>
  | z.infer<typeof voucherSchemaWithChildAgeConfirmation>;
